module.exports = __webpack_public_path__ + "static/img/shipped_on.934dda4.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/shipped_on.svg
// module id = 6c9h
// module chunks = 1